import { Injectable, inject } from '@angular/core';
import { Group, GroupsService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { MemberGroupApiActions, MemberGroupListActions, MemberGroupResolverActions } from './member-group.actions';

@Injectable()
export class GroupEffects {
  private readonly groupService = inject(GroupsService);
  private readonly actions$ = inject(Actions);

  groupMemberLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberGroupResolverActions.memberGroupsRequested),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.getNestedGroups({ id: group.id }),
          (groups: Group[]) => MemberGroupApiActions.memberGroupsLoaded({ groups }),
          (error) => MemberGroupApiActions.memberGroupsLoadedError({ error })
        )
      )
    );
  });

  groupMemberDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberGroupApiActions.memberGroupsGroupDeleted),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.removeGroupFromGroup({ id: group.parentId ?? '', groupId: group.id }),
          () => MemberGroupListActions.memberGroupsDeleted({ group }),
          (error) => MemberGroupApiActions.memberGroupsDeletedError({ error })
        )
      )
    );
  });

  groupMemberAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberGroupApiActions.memberGroupsAdded),
      mergeMap(({ group, groupToAdd }) =>
        safeMap(
          this.groupService.addGroupToGroup({ id: group.id, memberModel: { id: groupToAdd.id } }),
          () => MemberGroupListActions.memberGroupsAdded({ group, groupToAdd }),
          (error) => MemberGroupApiActions.memberGroupsAddedError({ error })
        )
      )
    );
  });
}
